// Abide Patterns
Foundation.Abide.defaults.patterns['phoneNumber'] = /^((\(\d{3}\)?)|(\d{3}))([\s-./]?)(\d{3})([\s-./]?)(\d{4})$/;
Foundation.Abide.defaults.patterns['zipCode'] = /^[0-9]{5}(?:-[0-9]{4})?$/;
Foundation.Abide.defaults.patterns['expDate'] = /^(0[1-9]|1[0-2])\/?([0-9]{4}|[0-9]{2})$/;
Foundation.Abide.defaults.patterns['punchh_password'] = /^(.){8,}$/;

jQuery(document).foundation();
